export default __webpack_public_path__ + "static/media/promo 4.bc022f9b.PNG";